import {PageLayout, InvoicesAdvancedTable, Placeholder} from '~/components'
import {SearchPageHeader} from '../search_header'
import {useHandleSearch, useFetchSearch, useSearchPlaceholderProps} from '../hooks'
import {Invoice} from '@eitje/api'
import {useAddOrganisationEnvironments} from '~/cores/billing/unpaid_invoices/index/use_unpaid_invoice_data'

export const SearchInvoice = () => {
	const {handleChange, handleKeyDown, handleClear, searchValue, searchQuery} = useHandleSearch('invoice')

	const {searchResults, isLoading} = useFetchSearch({
		searchQuery,
		requiredRecords: ['billingInfos', 'organisations', 'environments'],
		model: Invoice,
	})

	const placeholderProps = useSearchPlaceholderProps({searchResults, searchQuery, isLoading})

	const items = useAddOrganisationEnvironments(searchResults)

	return (
		<PageLayout
			name="invoices"
			headers={
				<SearchPageHeader
					headerLabel="common.invoices"
					count={searchResults.length}
					searchDropdownProps={{triggerText: 'common.invoice'}}
					searchInputProps={{searchValue, handleChange, handleKeyDown, handleClear}}
					searchExplanationPopoutProps={{title: 'invoice.search', body: 'invoice.popout.body'}}
				/>
			}
		>
			{placeholderProps ? <Placeholder {...placeholderProps} /> : <InvoicesAdvancedTable data={items} />}
		</PageLayout>
	)
}
